//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { GenericInvoiceInputItem } from './GenericInvoiceInputItem';
import { IReportFamilyIDsInputItem } from './IReportFamilyIDsInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { ReportType } from './Enums';

export class InvoiceInputItem extends GenericInvoiceInputItem implements IReportFamilyIDsInputItem, IReportDateRangeInputItem {
    FamilyIDs: string[] = [];
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    EventCategoryIDs: string[] = [];
    IncludeBalanceForward: boolean = false;
    SkipZeroOwingFamilies: boolean = false;
    readonly Type: ReportType = ReportType.Invoice;

    constructor(initializer?: Partial<Omit<InvoiceInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "InvoiceInputItem";
}
